import { useEffect, useMemo, useState } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import { useForm, FormProvider } from "react-hook-form";
// import { DevTool } from "@hookform/devtools";
import useAxios from "../../../hooks/useAxios";
import axiosInstance from "../../../apis/commonAPI";
// import {SESSION_DATA, user,} from "../../constants";
// import { useSelector } from "react-redux";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { CiSquarePlus } from "react-icons/ci";
import { FaPlus } from "react-icons/fa";


const AddEditDegree = () => {
  const navigate = useNavigate();
const { id } = useParams();
  const [addUpdate, setAddUpdate] = useState(false);
 



  const [degreeData, errorDegree, loadingDegree, axiosDegree] =
  useAxios();
  const [submitForm, errorSubmit, loadingSubmit, axiosSubmit] =
    useAxios();

    const GET_DEG_URL = id && id != undefined?`master/getDegreeData/${id}`:"";

  const SUBMIT_FORM_DATA_URL = id && id != undefined?`master/updateDegreeData/${id}`:'master/createDegreeData';


const getDegree = (url) => {
    axiosDegree({
        axiosInstance: axiosInstance,
        url: url,
        method: "GET",
      });
    };

      useEffect(() => {
          const fetchStateData = async () => {
            if (!id) return;
        
            try {
               getDegree(GET_DEG_URL);
            
            } catch (error) {
              console.error("Error fetching  data:", error);
            }
          };
        
          fetchStateData();
        }, [GET_DEG_URL]);

         useEffect(() => {
              const fetchStateDataB = async () => {
                if (!id) return;
            
                try {
                  if (degreeData?.length > 0) {
                    setValue("degreeName", degreeData[0].degreeName);
                  } else {
                    console.warn("No degree data found for the given ID");
                  }
                } catch (error) {
                  console.error("Error fetching  data:", error);
                }
              };
            
              fetchStateDataB();
            }, [loadingDegree]);

  const form = useForm({
    defaultValues: {
     degree:"BTech"
    },
  });
  const {
    register,
    control,
    handleSubmit,
    formState,
    watch,
    setValue,
    getValues,
    resetField,
    reset,
  } = form;
  const { errors } = formState;

  const toTitleCase = (str) => {
    return str.toLowerCase().replace(/(^|\s|-|\')(\w)/g, (match) => {
      return match.toUpperCase();
    });
  };

  const onFormSubmit = async (data) => {
    // let getSpecArray = [];
   
    // for (let numRow = 0; numRow < specializationCount.length; numRow++) {

    //   if(data[`specializationName_${numRow}`] !=="" && data[`specializationName_${numRow}`] !== null && data[`specializationName_${numRow}`] !== undefined){
    //     getSpecArray.push({
        
    //       specializationName: toTitleCase(data[`specializationName_${numRow}`]),
          
    //     });
    //   }
     
    // }
   

    

    let formData = {
      degreeName: data.degreeName,
      // specializations: getSpecArray,
      status: "A"
     
    };
console.log("formData test",formData);
    await axiosSubmit({
      axiosInstance: axiosInstance,
      url: SUBMIT_FORM_DATA_URL,
      method: "POST",
      requestConfig: {
        data: formData,
      },
    });

    setAddUpdate(true);
  };
  useEffect(() => {
    if (errorSubmit) {
      toast.error(
        `Your information could not be Added!!error:${errorSubmit}`,
        {
          position: toast.POSITION.TOP_RIGHT,
        }
      );
    } else if (addUpdate) {
      navigate(
        `/master/degreelisting`
      );
    }
  }, [loadingSubmit, errorSubmit]);

  return (
    <>
      <div className="card min-height-100">
        <div className="card-title flex-row">
          <h2>{id ? "Edit" : "Add"} Degree </h2>
          <Link to="/master/degreeListing">
            <button className="btn btn-blue rounded-10">Back</button>
          </Link>
        </div>
        <ToastContainer />

        <FormProvider {...form}>
          <form onSubmit={handleSubmit(onFormSubmit)} noValidate>
            <div className="row mt-30">
            <div className="col-md-4  tank-col-info">
                <label htmlFor="degreeName" className="text-gray text-semi-bold">
                  Degree Name<span className="text-red">*</span>
                </label>
                <input
                  id="degreeName"
                  {...register("degreeName", {
                    required: {
                      value: true,
                      message: "Degree Name Field is Required",
                    },
                  })}
                  type="text"
                  className="form-control rounded-10 mb-15"
                  placeholder="Enter Degree name"
                />
                <p className="text-red">{errors.degreeName?.message}</p>
              </div>
              {/* {
                specializationCount?.map((fetchRows,index) => (
                  <div className="col-md-4  tank-col-info">
                  <label htmlFor={`specializationName_${index}`} className="text-gray text-semi-bold">
                    Specialization: <span className="text-red">*</span>
                  </label>
                  <input
                    id={`specializationName_${index}`}
                    {...register(`specializationName_${index}`, {
                      required: {
                        // value: true,
                        message: "specialization Name Field is Required",
                      },
                    })}
                    type="text"
                    className="form-control rounded-10 mb-15"
                    placeholder="Enter Specialization"
                  />
                  <p className="text-red">{errors?.[`specializationName_${index}`]?.message}</p>
                </div>

                ))
              } */}
          
              {/* <div className="col-md-4 text-left mt-20">
                <button
                  className="btn btn-sm btn-secondary rounded-10"
                  title= "click to add specialization"
                ><FaPlus /></button>
              </div> */}
            
            

              <div className="col-md-12 text-center">
                <input
                  type="submit"
                  className="btn btn-red rounded-10"
                  value="Submit"
                />
              </div>
            </div>
          </form>
        </FormProvider>

       
      </div>
    </>
  );
};

export default AddEditDegree;
